import { BaseService } from "../base/BaseService";
import { IExerciseSession } from "./IExerciseSession";
import { IQuestion } from "./IQuestion";
import { IQuestionRecord } from "./IQuestionRecord";
import { IExerciseProgress } from "./IExerciseProgress";
import { IExerciseService } from "./IExerciseService";
import { IExcercise } from "./IExcercise";

export class ExerciseService extends BaseService implements IExerciseService {
        /*
    private calendarRepository: ICalendarRepository;
    constructor() {
        super();
        this.calendarRepository = this.dependencies.calendarRepository
    }*/
    async getAvailableExercises(): Promise<IExcercise[]> {
        const datasource = await fetch("./data/datasources.json");
        const datasources = (await datasource.json()) as IExcercise[];
        return datasources;
    }
    async getExerciseQuestions(exercise: IExcercise): Promise<IQuestion[]> {
        let data = [];
        try {
            const datasource = await fetch(exercise.datasource);
            const text = await datasource.text();
            // eslint-disable-next-line
            const fn = new Function(`return async () => { ${text} };`);
            const ds = fn() as Function;
            data = await ds();
        } catch (error) {
            console.log(error);
        }
        return data as IQuestion[];
    }
    getExerciseSession(questions: IQuestion[], numberOfBuckets: number = 3): IExerciseSession {
        return {
            currentQuestion: null,
            questions: questions.map(q => ({ question: q, bucket: 0 })),
            numberOfBuckets: numberOfBuckets
        };
    }
    answerQuestion(question: IQuestionRecord, success: boolean) {
        if (success) {
            question.bucket += 1;
        } else {
            question.bucket = 0;
        }
    }
    getRandomQuestion<T>(arr: T[]): T {
        return arr[Math.floor(Math.random() * arr.length)]
    }
    getNextQuestion(session: IExerciseSession) {
        let availableQuestions = session.questions.filter(q => q.bucket < session.numberOfBuckets);
        // prevent the random to become the previous card, when cards available > 1
        if (availableQuestions.length > 1 && session.currentQuestion) {
            availableQuestions = availableQuestions.filter(q => q !== session.currentQuestion);
        }
        session.currentQuestion = this.getRandomQuestion(availableQuestions);
        return session.currentQuestion;
    }

    // getProgress() {
    //     const cardsAvailable = cards.filter(c => c.bucket < numberOfBuckets).length;
    //     return cardsAvailable / cards.length;
    // }
    getProgress(session: IExerciseSession): IExerciseProgress {
        const questionsTotal = session.questions.length * session.numberOfBuckets;
        const questionsTodo = session.questions.reduce((acc, curr) => acc += (session.numberOfBuckets - curr.bucket), 0);
        return {
            progress: (questionsTotal - questionsTodo) / questionsTotal,
            done: (questionsTotal - questionsTodo),
            total: questionsTotal
        }
    }
}
